import { wijzneusApi } from './wijzneus-api';
const getPortalDropdown = () => {
    return wijzneusApi.get(`portals`);
};
const PortalApi = {
    getPortalDropdown,
};
export default PortalApi;
